module.exports = __webpack_public_path__ + "static/media/arabic-2.11535637.jpeg";